module.exports = __webpack_public_path__ + "img/car-30.8763fdd3.jpg";